import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import AddOnsTable from './addons-table';
import { SHOW_ALL } from '../consts';

const Table = injectIntl((props) => {
  const [ status, selectedStatus ] = useState(SHOW_ALL);

  const handleStateOnFilterChange = (statusFilter) => {
    selectedStatus(statusFilter);
  }
 
  return  <AddOnsTable
            handleStateOnFilterChange={handleStateOnFilterChange}
            hostId={props.hostId}
            intl={props.intl}
            selectedStatus={status}
            hasPermissionForManageAddOns={props.hasPermissionForManageAddOns}
            history={props.history}
          />;
});

export default Table;
